export const touchDoubleTap = {
  mounted(el, binding) {
    let lastTapTime = 0
    let lastTapPos = { x: 0, y: 0 }

    // Android 标准参数
    const DOUBLE_TAP_TIMEOUT = 300
    const DOUBLE_TAP_SLOP = 20 // 允许手指抖动的像素范围

    el._handleTouchStart = (e) => {
      const now = Date.now()
      const touch = e.touches[0]
      const currentPos = { x: touch.pageX, y: touch.pageY }

      const timeDiff = now - lastTapTime

      // 计算两次点击之间的物理距离（勾股定理）
      const distance = Math.sqrt(
        Math.pow(currentPos.x - lastTapPos.x, 2) +
        Math.pow(currentPos.y - lastTapPos.y, 2)
      )

      if (timeDiff > 0 && timeDiff < DOUBLE_TAP_TIMEOUT && distance < DOUBLE_TAP_SLOP) {
        // 判定成功：执行绑定函数
        if (typeof binding.value === 'function') {
          binding.value(e)
        }
        lastTapTime = 0 // 重置
      } else {
        lastTapTime = now
        lastTapPos = currentPos
      }
    }

    el.addEventListener('touchstart', el._handleTouchStart)

    // 性能优化：在 CSS 中禁用系统默认双击缩放
    el.style.touchAction = 'manipulation'
  },

  unmounted(el) {
    // 销毁时移除监听，防止内存泄漏
    el.removeEventListener('touchstart', el._handleTouchStart)
  }
}
